import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import { getsettdata, updateSettings } from '../../actions/users';
import Modal from 'react-modal';
import isEmpty from '../../lib/isEmpty';


var tempname;
var templink;

const UserSettings = () => {
  const [userdet, setUser] = useState();
  const [dummyarr, setdummyarr] = useState()
  const [modalshow, setmodalshow] = useState(false)
  const [isedit, setisedit] = useState(false)
  const [wname, setwname] = useState('')
  const [wlink, setwlink] = useState('')
  const [objectcrea, setobjectcrea] = useState([])
  const [validateError, setValidateError] = useState({});

  const customStyles1 = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  useEffect(() =>{
    if(!isEmpty(objectcrea))
    {
    aftersubmit()
    }
  },[objectcrea])

  const aftersubmit = async() => {
    let reqData = {
      objectcrea
    }
    let { error, result } = await updateSettings(reqData);
    if (isEmpty(error)) {
      setisedit(false)
      templink = ''
      tempname = ''
      setwname('')
      setwname('')
      toastAlert("success", 'User settings Updated');
      setmodalshow(false)
      setTimeout(() => {
        window.location.reload()
      }, 1000);
      
    } else {
      setValidateError(error);
    }
  }

  useEffect(() => {
    getUserData();
  }, [])

  const getUserData = async () => {
    var test = await getsettdata();
    if (test && test.userValue && test && test.userValue.social.length != 0) {
      setUser(test.userValue.social)
    }
  }

  const editrec = (r) => {
    setdummyarr(r)
    setmodalshow(true)
    setisedit(true)
    setwname(Object.keys(r))
    setwlink(Object.values(r))
  }

  const handleEditSubmit = () =>{
    var index = userdet.indexOf(dummyarr)
    var temp = ({ [wname]: wlink })
    if (index !== -1) {
      userdet.splice(index, 1,temp);
  }
    setobjectcrea(userdet)
  }

  const handleFormSubmit = async (e) => {
    var temp2 = []
    var temp3 = []
    if(!isEmpty(userdet)){
      temp2 = userdet
    }
      temp3[0] = ({ [tempname]: templink })
      temp2.push(temp3[0])
      setobjectcrea(temp2)
  }

  const onChange = (e) => {
    const { id, value } = e.target
    if (id == "WebsiteName") {
      tempname = value
      setwname(value)
    }
    if (id == "WebsiteLink") {
      templink = value
      setwlink(value)
    }
  }

  const columns = [
    {
      key: "ind",
      text: "SNO",
      className: "name",
      align: "center",
      sortable: false,
      cell: (row, index, column, id) => <p className='text-center exchange_table_values'>{index + 1}</p>,
    },
    {
      key: "details",
      text: "Social Account",
      className: "Name",
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div>
            <p className='text-center exchange_table_values'>{Object.keys(record)}</p>
          </div>
        );
      }
    },
    {
      key: "nfttag",
      text: "Social Link",
      className: "Name",
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div>
            <p className='text-center exchange_table_values'>{Object.values(record)}</p>
          </div>
        );
      }
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div className='text-center exchange_table_values'>
            <button
              data-toggle="modal"
              data-target="#update-template-modal"
              className="btn btn-primary btn-sm"
              onClick={() => editrec(record)}
              style={{ marginRight: '5px' }}>
              <i className="fa fa-edit"></i>
            </button>
          </div>
        );
      }
    },
  ];
  const config = {
    page_size: 5,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: <> Previous </>,
        next: <>Next</>,
        last: "Last",
      },
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
};
  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'Social Links'} />

            <div className="common_page_scroller mt-5 pe-2">
              <div className="page_header">
                <h2>Social Links</h2>
              </div>
              <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                  config={config}
                  records={userdet}
                  columns={columns}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={modalshow}
        style={customStyles1}
        contentLabel="Example Modal"
      >
         <div className='newthememodal'>
        <div className='text-end'>
        <button onClick={() => { setmodalshow(false) }} className="closebtns"><i class="fa fa-times"></i></button>
        </div>
        <h5>Social Account</h5>
        <div>
          <div>
            <label htmlFor='WebsiteLink' className='text-dark mb-2'>Social Platform Link</label>
            <input id="WebsiteLink" className='form-control' value={isedit && wlink || templink} onChange={(e) => onChange(e)} fullWidth />
          </div>
        </div>
        {isedit ?
          <button color="primary" onClick={(e) => { handleEditSubmit(e) }} className="btn addcate px-3 py-2 mt-3">Edit</button>
          :
          <button color="primary" onClick={(e) => { handleFormSubmit(e) }} className="btn addcate px-3 py-2 mt-3">Add</button>
        }

</div>

      </Modal>
    </>
  )
}

export default UserSettings